import { Field, Input, Label, Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { Fragment } from 'react/jsx-runtime';
import { Button } from '../../ui/components/Button';
import { SaveIcon } from '../../ui/icons/SaveIcon';
import { NewPlaylist } from '../types';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../store';
import { playlistActions } from '../slice';

type Props = {
  currentPlaylist: NewPlaylist
}

export const SaveButton = ({ currentPlaylist }: Props) => {

  const [name, setName] = useState<string>(currentPlaylist.name);
  const dispatch = useAppDispatch();

  const doSave = () => {
    dispatch(playlistActions.saveCurrentPlaylist({ name }));
  };

  useEffect(
    () => {
      setName(currentPlaylist.name);
    },
    [currentPlaylist.name]
  );

  return (
    <Popover as={Fragment}>
      <PopoverButton
        as={Button}
        title={`Save playlist${ currentPlaylist.modified ? ' (modified)' : '' }`}
      >
        <SaveIcon className='size-4 mr-1' /> Save
        { currentPlaylist.modified && '*' }
      </PopoverButton>
      <PopoverPanel
        anchor='bottom start'
        className='p-2 bg-jw-light-blue text-white z-50 rounded-sm min-w-[250px] flex flex-col'
      >
        {
          ({ close }) => (
            <>
              <Field className='flex items-center mb-1'>
                <Label>
                  Save playlist as
                </Label>
                <Input
                  className='ml-2'
                  onChange={(e) => setName(e.target.value)}
                  type='text'
                  value={name}
                />
              </Field>
              <div className='self-end flex'>
                <Button
                  onClick={() => close()}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => { doSave(); close(); }}
                >
                  <SaveIcon className='size-5 mr-2' /> Save
                </Button>
              </div>
            </>
          )
        }
      </PopoverPanel>
    </Popover>
  );
};
